import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import ExpenseLayout from 'Views/Page/Content/Modal/Layouts/FacetPlanOutcomeGoalOneTimeExpense/ExpenseLayout';
import MetaOverrideSet from './MetaOverrideSet';

const ExpensesForm = withStyles(theme => ({
  root: {
    padding: 0,
    margin: 0,
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    textAlign: 'center',
  },
}))(MetaCollectionFormInline);

const styles = theme => ({
  root: {
  },
  content: {
    width: '100%',
  },
  continueButton: {
    padding: theme.spacing(1),
  },
  stepNavigationContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    padding: theme.spacing(3),
  },
  form: {
    padding: 0,
  },
  help: {
    padding: theme.spacing(0, 2, 2, 2),
  },
});

const FacetPlanOutcomeGoalOneTimeExpense = ({
  className,
  classes,
}) => {
  const { resource, handleChange } = useMetaLayoutContext();

  const onAdd = () => {
    handleChange('expenses', resource.attr('expenses').create({
      addToCollection: true,
    }));
  };

  const onRemove = (i) => {
    resource.attr('expenses').resources().removeItemByIndex(i);
    handleChange('expenses', resource.attr('expenses'));
  };

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {resource.attr('expenses') && <ExpensesForm
        collection={resource.attr('expenses')}
        metaOverrideSet={MetaOverrideSet}
        addButtonText={'Add New Expense'}
        FormProps={{
          layout: ExpenseLayout,
          noIndividualSubmitButtons: true,
          classes: {
            root: classes.form,
          },
          LayoutProps: {
            onRemove,
          },
        }}
        onAdd={onAdd}
      />}
    </Box>
  );
};

FacetPlanOutcomeGoalOneTimeExpense.defaultProps = {
  className: '',
};

FacetPlanOutcomeGoalOneTimeExpense.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FacetPlanOutcomeGoalOneTimeExpense);
